<template>
  <div ref="layout" class="page-form">
    <h3 class="title">货权转移申请单详情</h3>

    <div class="form-container">
      <div class="tools">
        <form-button name="返回" @click="$router.go(-1)" />
      </div>
      <el-form ref="form" inline size="mini" disabled label-width="110px" :model="transferApplyPo">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="transferApplyPo.createdByName"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                v-model="transferApplyPo.createdDate"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="货权接收客户" prop="receiveClient">
              <el-input v-model="transferApplyPo.receiveClient" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="转移明细"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>

      <TableCommon
        title="货权转移历史"
        :custome-config="() => vxeShowCustom('xTable2')"
      >
        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions3.columns"
          :data="gridOptions3.data"
        />
      </TableCommon>

      <TableCommon
        title="附件"
        :custome-config="() => vxeShowCustom('xTable3')"
      >
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions2.columns"
          :data="gridOptions2.data"
        >
          <template #fileName="{row}">
            <span class="blue" @click="dowLoadFile(row)">{{ row.fileName }}</span>
          </template>
          <template #createdDate="{row}">
            <span>{{ row.createdDate || row.creator.createdDate }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon style="margin-top: 10px" title="流程轨迹" :show-custome="false">
        <el-table
          :data="tablePathData.data"
          border
          :header-cell-style="{
            background: '#f2f8fe',
            color: '#333',
            fontSize: '12px',
            fontWeight: '600',
            lineHeight: '27px',
            padding: 0
          }"
          :row-style="{
            fontSize: '12px'
          }"
          :cell-style="{
            padding: '5px 0',
            textAlign: 'left'
          }"
        >
          <el-table-column
            prop="subProcUnitName"
            label="环节描述"
            width="180"
            :formatter="(r,c,value) => value || r.name"
          />
          <el-table-column
            prop="handler"
            label="处理人"
            width="180"
            :formatter="(r,c,value) => value.split('.')[1]"
          />
          <el-table-column
            prop="resultTextView"
            label="处理结果"
            width="120px"
          />
          <el-table-column
            prop="opinion"
            label="意见"
          />
          <!-- <el-table-column
          prop="taskKindTextView"
          label="任务类型"
        /> -->
          <el-table-column
            prop="startTime"
            label="开始时间"
            width="150px"
          />
          <el-table-column
            prop="endTime"
            label="结束时间"
            width="150px"
          />
          <el-table-column
            prop="duration"
            label="耗时"
            width="70px"
            :formatter="(r,c,value) => value ? value + 'h' : value"
          />
          <el-table-column
            prop="statusName"
            label="状态"
            width="90px"
          />
        </el-table>
      </TableCommon>

      <btky-footer :form-data="transferApplyPo" :is-search="true" />
    </div>
  </div>
</template>
<script>
import { transfergoodsrightsFindById, getTransfergoodsrightsHist } from '@/api/applyForGoods/index'
import { queryFiles, apiAttachmentDownFile } from '@/api/common'
import { download } from '@/utils/frontExport'
import { queryApprovalHistoryByBizId } from '@/api/flowHander'
export default {
  name: 'cargo-transfer-search-detail',
  data() {
    return {
      processKey: 'transfergoodsrights',
      selectDataOptions: {},
      transferApplyPo: {
        id: '',
        taskId: '',
        bizId: '',
        status: 0,
        billCode: '',
        billStatus: 'E001',
        deptId: '',
        deptName: '',
        endDate: '',
        expireDate: '',
        fillinDate: '',
        fullId: '',
        organId: '',
        organName: '',
        personMemberId: '',
        personMemberName: '',
        positionId: '',
        positionName: '',
        createdById: '',
        createdByName: '',
        createdDate: '',

        invoiceNo: '',
        transferClient: '',
        receiveClient: '',
        receiveClientCode: '',
        productCode: '',
        productDesc: '',
        invoiceQuantity: '',
        deliveryQuantity: '',
        transferedQuantity: '',
        thisTransferQuantity: '',
        planType: '',
        planYear: ''
      },
      gridOptions: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'invoiceDetailId', title: '制票通知单明细ID', width: 120, visible: false },
          { field: 'invoiceNo', title: '制票通知单号', width: 120 },
          { field: 'planYear', title: '年度', width: 120 },
          { field: 'planTypeTextView', title: '计划类型', width: 120 },
          { field: 'productDesc', title: '产品名称', width: 120 },
          { field: 'invoiceQuantity', title: '开票量（件）', width: 120, visible: false },
          { field: 'deliveryQuantity', title: '已发货量', width: 120 },
          { field: 'transferedQuantity', title: '已转移量', width: 120 },
          { field: 'surplusQty', title: '剩余量', width: 120 },
          { field: 'thisTransferQuantity', title: '本次货权转移量', width: 120 },
          { field: 'remark', title: '备注', width: 120 }
        ],
        data: []
      },
      gridOptions3: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'createdDate', title: '转移时间', width: 120 },
          { field: 'transferClient', title: '转出客户', width: 120 },
          { field: 'receiveClientCode', title: '接收客户编码', width: 120 },
          { field: 'receiveClient', title: '接收客户名称', width: 220 },
          { field: 'invoiceNo', title: '制票通知单号', width: 120 },
          { field: 'productCode', title: '产品编号', width: 120 },
          { field: 'productDesc', title: '产品名称', width: 240 },
          { field: 'thisTransferQuantity', title: '转出量', width: 120 }
        ],
        data: []
      },
      gridOptions2: {
        columns: [
          { type: 'seq', title: '序号', filed: 'seq', width: 50 },
          {
            field: 'fileName',
            title: '附件名称',
            slots: {
              default: 'fileName'
            }
          },
          {
            field: 'fileKind',
            title: '附件类型'
          },
          {
            field: 'fileSize',
            title: '大小'
          },
          {
            field: 'createdDate',
            title: '上传时间',
            slots: {
              default: 'createdDate'
            }
          }
        ],
        data: []
      },
      tablePathData: {
        // columns: [
        //   { title: '环节描述', field: 'subProcUnitName', formatter: ({ cellValue, row }) => cellValue || row.name },
        //   { title: '处理人', field: 'handler' },
        //   { title: '处理结果', field: 'resultTextView' },
        //   { title: '意见', field: 'opinion' },
        //   { title: '任务类型', field: 'taskKindTextView' },
        //   { title: '开始时间', field: 'startTime' },
        //   { title: '结束时间', field: 'endTime' },
        //   { title: '耗时（小时）', field: 'duration' },
        //   { title: '状态', field: 'statusName' }
        // ],
        data: []
      }
    }
  },
  created() {
    const { id } = this.$route.query

    if (id) {
      this.transfergoodsrightsFindById(id)
      this.flowPath()
    }
  },
  methods: {
    flowPath() {
      queryApprovalHistoryByBizId({ bizId: this.$route.query.id })
        .then(res => {
          if (res.data) {
            this.tablePathData.data = res.data.Rows.filter(v => v.statusName !== '已取消')
          }
        })
        .catch(() => {})
    },
    async transfergoodsrightsFindById(id) {
      const res = await transfergoodsrightsFindById({ id })
      Object.assign(this.transferApplyPo, res.data)
      this.gridOptions2.data = this.transferApplyPo.attachmentList
      this.gridOptions.data = this.transferApplyPo.transferProductDtlList
      this.transferApplyPo.taskId = this.$route.query.taskId
      this.getFiles()
      const histData = await getTransfergoodsrightsHist({ invoiceItemId: res.data.transferProductDtlList[0].invoiceDetailId })
      this.gridOptions3.data = histData.data
    },
    async dowLoadFile({ id, fileName }) {
      const res = await apiAttachmentDownFile({ id })
      download(res.data, fileName)
    },
    async getFiles() {
      const params = {
        bizId: this.transferApplyPo.id,
        bizCode: this.processKey
      }
      const { data } = await queryFiles(params)
      this.gridOptions2.data = data
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/cargoTransferSearchDetail.vue